<template>
  <div class="totalregisters">
    <p class="category" style="text-transform:none;">Total: {{ total }} {{ totalText }}</p>
  </div>
</template>
<script>
export default {
  props: {
    total: {
      type: Number,
      default: null,
    },
    totalText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
};
</script>
